import { BankAccountType } from '@/types/bankAccountType';
import {
  Account,
  calizaWalletUSDC,
  calizaWalletUSDT,
  ContactType,
  FiatAccount,
} from '@/types/contacts';
import { CurrencyCodeType } from '@/types/currency';
import { FiatAccountType } from '@/types/fiatAccountType';
import { Transaction, TransactionType } from '@/types/transaction';
import { isPixInLocalInfo } from '@/types/transaction.ext';

export const resolveToAccount = (transaction: Transaction): Account | null => {
  const { type, toAmount, toAccount } = transaction;
  if (toAccount) {
    return toAccount;
  }

  switch (type) {
    case TransactionType.DEPOSIT:
    case TransactionType.EXCHANGE:
      if (toAmount.currencyCode === CurrencyCodeType.USDC) {
        return calizaWalletUSDC;
      } else if (toAmount.currencyCode === CurrencyCodeType.USDT) {
        return calizaWalletUSDT;
      } else {
        return createExternalAccount(transaction);
      }
    case TransactionType.TRANSFER:
      console.debug('to account is mandatory for transfer transactions');
      return null;
    case TransactionType.WITHDRAWAL:
      return createExternalAccount(transaction);
    default:
      console.debug('cannot determine to account for transaction type ' + transaction.type);
      return null;
  }
};

export const resolveFromAccount = (transaction: Transaction): Account | null => {
  const { type, fromAmount, fromAccount } = transaction;
  if (fromAccount) {
    return fromAccount;
  }

  switch (type) {
    case TransactionType.WITHDRAWAL:
    case TransactionType.EXCHANGE:
      if (fromAmount.currencyCode === CurrencyCodeType.USDC) {
        return calizaWalletUSDC;
      } else if (fromAmount.currencyCode === CurrencyCodeType.USDT) {
        return calizaWalletUSDT;
      } else {
        return createExternalAccount(transaction);
      }
    case TransactionType.DEPOSIT:
      return createExternalAccount(transaction);
    case TransactionType.TRANSFER:
      if (fromAmount.currencyCode === CurrencyCodeType.USDC) {
        return calizaWalletUSDC;
      } else if (fromAmount.currencyCode === CurrencyCodeType.USDT) {
        return calizaWalletUSDT;
      } else {
        return createExternalAccount(transaction);
      }

    default:
      throw new Error('cannot determine from account for transaction type ' + transaction.type);
  }
};

const createExternalAccount = (transaction: Transaction): Account => {
  if (isPixInLocalInfo(transaction.localInfo)) {
    return externalPixPlaceholderAccount;
  }

  return externalACHPlaceholderAccount;
};

const externalACHPlaceholderAccount: FiatAccount = {
  id: '',
  name: 'EXTERNAL_ACCOUNT_ACH',
  beneficiaryId: '',
  belongsToBeneficiary: false,
  fiatAccountType: FiatAccountType.ach,
  accountDetails: {
    achDetails: {
      bankInfo: {
        name: 'EXTERNAL_ACCOUNT_ACH',
        street1: '',
        street2: '',
        postalCode: '',
        city: '',
        state: '',
        country: '',
        routingNumber: '',
      },
      personInfo: {
        accountType: BankAccountType.checking,
        type: ContactType.individual,
        name: '',
        street1: '',
        postalCode: '',
        city: '',
        state: '',
        country: '',
        routingKey: '',
        accountNumber: '',
      },
    },
  },
};

const externalPixPlaceholderAccount: FiatAccount = {
  id: '',
  name: 'EXTERNAL_ACCOUNT_PIX',
  beneficiaryId: '',
  belongsToBeneficiary: false,
  fiatAccountType: FiatAccountType.pix,
  accountDetails: {
    pixDetails: {
      pixKey: '',
    },
  },
};
